import React from 'react';
import { Card, CardHeader, CardBody } from 'reactstrap';

const calculateHostStats = dataCenters => {
  const stats = { up: 0, down: 0, unreach: 0, pend: 0, total: 0 };
  dataCenters.forEach(dataCenter => dataCenter.hosts.forEach(host => {
      stats[host.state.toLowerCase()] += 1;
      stats.total += 1;
    }),
  );
  return stats;
};

const HostStat = ({ name, count }) => {
  return (
    <div style={{ marginTop: 4 }}>
      <small>{name} {count > 0 && `(${count})`}</small>
    </div>
  );
};

const HostStats = ({ dataCenters }) => {
  const { up, down, unreach, pend, total } = calculateHostStats(dataCenters);
  return (
    <Card style={{ textAlign: 'left', background: 'none', border: 0 }}>
      <CardHeader style={{ background: 'none', border: 0 }}>
        Hosts <small>{total > 0 && `(${total})`}</small>
      </CardHeader>
      <CardBody style={{ paddingTop: 6, minWidth: 96, borderTop: '1px solid #ddd' }}>
        <HostStat name="Up" count={up} />
        <HostStat name="Down" count={down} />
        <HostStat name="Unreachable" count={unreach} />
        <HostStat name="Pending" count={pend} />
      </CardBody>
    </Card>
  );
};

export default HostStats;
